// TASK: T-001 - Make entire Shop Pay financing box clickable

document.addEventListener('click', function (event) {
  const path = event.composedPath();

  const paymentTerms = path.find(
    element => element?.tagName === 'SHOPIFY-PAYMENT-TERMS'
  );

  if (!paymentTerms) return;

  // Don't interfere when the actual ? button is clicked
  const clickedCTA = path.some(
    element => element?.id === 'shopify-installments-cta'
  );

  if (clickedCTA) return;

  const shopPayButton =
    paymentTerms.shadowRoot?.querySelector('#shopify-installments-cta') ||
    paymentTerms.querySelector('#shopify-installments-cta');

  if (shopPayButton) {
    shopPayButton.click();
  }
});